// extracted by mini-css-extract-plugin
export default {"heading":"awIwhxLwWQsGmWcqTArB","tou":"E52sitowQZXfgz9tAMxI"};